import {
  CHAINE_GET_SUCCES,
  CHAINE_GET_ECHEC,
  CHAINE_UPDATE_SUCCES,
  CHAINE_UPDATE_ECHEC,
} from "../constantes/chaineOrclConstantes";
import Axios from "axios";

//const uri = `http://${manifest.debuggerHost.split(":").shift()}:5000`;

//const uri = `https://ahmed.prod-manager.tk/back`;
//const uri = `https://gestpro.globalsystempro.com/back`;
import { store } from "../store";

let uri = "";
function changeURi() {
  const cliServ = store.getState().cliServState.cliServ;
  return (uri =
    cliServ != 0
      ? cliServ == "SERV1"
        ? process.env.REACT_APP_SERV_1
        : process.env.REACT_APP_SERV_2
      : process.env.REACT_APP_SERV_1);
}
changeURi();

export const chaineGet = () => async (dispatch) => {
  try {
    const { data } = await Axios.get(`${uri}/api/chaineOrcl`);
    dispatch({ type: CHAINE_GET_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: CHAINE_GET_ECHEC, payload: error });

    alert(error);
  }
};
export const chaineUpdate = (user, pwd, host, database) => async (dispatch) => {
  try {
    const { data } = await Axios.put(`${uri}/api/chaineOrcl`, {
      user,
      pwd,
      host,
      database,
    });
    dispatch({ type: CHAINE_UPDATE_SUCCES, payload: data });
  } catch (error) {
    dispatch({ type: CHAINE_UPDATE_ECHEC, payload: error });

    alert(error);
  }
};
